//#region imports
import { Component, OnInit } from '@angular/core';
import { CharacteristicService } from '../services/characteristic.service';
import { AppConstants } from '../app.constants';
import { ActivatedRoute } from '@angular/router';
import { SectionService } from '../services/section.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { GuaranteeService } from '../services/guarantee.service';
import { DomSanitizer } from '@angular/platform-browser';
//#endregion

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  //#region variables
  clientId;
  language;
  federaleURL = AppConstants.FederaleURL.MyFederale;
  Customer_text;
  //#endregion

  //#region methods
  constructor(
    private characteristicService: CharacteristicService,
    private activatedRoute: ActivatedRoute, private sectionService: SectionService, private translate: TranslateService, 
    private http: HttpClient, private guranteeservice: GuaranteeService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.clientId = params.clientId;
      this.language = params.language;
      if (this.language === null || this.language === undefined ) {this.language = this.guranteeservice.getLanguage();}
      if (this.language == null || this.language == undefined) {this.loadCustomerText('FR'); }
      else {this.loadCustomerText(this.language.toUpperCase()); }
    });
    this.guranteeservice.langvalue.subscribe(value => {
      this.loadCustomerText(value);
    });
  }
loadCustomerText(langValue) {
  this.guranteeservice.getDataFR(langValue).subscribe(data => {
    this.Customer_text = this.sanitizer.bypassSecurityTrustHtml(data);
  });
}
  btnStartSimulation() {
    this.characteristicService.setShowLandingPage(false);
    this.sectionService.navigate('characteristics', this.clientId, null, this.language);
  }

  



  //#endregion
}
